<template>
  <table class="table is-bordered w-100">
    <thead>
      <tr>
        <th v-for="day in days" :key="day">{{day}}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, i) in dates" :key="i">
        <td
          v-for="(day, j) in row"
          :key="j"
          :data-day="day.day"
          class="day is-pointer"
          :class="[{'is-selected': isSelected(day) && day.currentMonth}, {'not-curent-month': !day.currentMonth}, {'is-today': isToday(day)}, {'not-available': hasRestriction(day)}]"
          @click="selectDay(day)"
        >
          <div>{{day.text}}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { chunk } from "../utils/base";
import locale from "../locale/locale";

import moment from "moment";

import { createDate } from "../utils/date";

export default {
  name: "datepicker-list-day",
  props: {
    calendarYear: {
      type: Number,
      default() {
        return new Date().getFullYear();
      },
    },
    calendarMonth: {
      type: Number,
      default() {
        return new Date().getMonth();
      },
    },
    calendarDate: {
      type: String,
      default() {
        return moment(new Date()).format("DD/MM/YYYY");
      },
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    dateFormat: {
      type: String,
      default: "DD/MM/YYYY",
    },
  },
  data() {
    return {
      today: new Date(),
    };
  },
  computed: {
    date() {
      return moment(this.calendarDate, "DD/MM/YYYY").toDate();
    },
    calendarMinDate() {
      return moment(this.minDate, "DD/MM/YYYY").toDate();
    },
    calendarMaxDate() {
      return moment(this.maxDate, "DD/MM/YYYY").toDate();
    },
    firstDayOfWeek() {
      return locale.info.firstDayOfWeek || 0;
    },
    days() {
      let days = locale.info.weekdaysMin;
      return days
        .concat(days)
        .splice(this.firstDayOfWeek, 7);
    },
    dates() {
      let dates = [];
      let year = this.calendarYear;
      let month = this.calendarMonth;

      const calendar = createDate(year, month, 0);
      const lastDayInLastMonth = calendar.getDate();

      const firstDayInLastMonth =
        lastDayInLastMonth -
        ((calendar.getDay() + 7 - this.firstDayOfWeek) % 7);
      for (let i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
        const day = i - lastDayInLastMonth;
        dates.push({ day, year, month, text: i, currentMonth: false });
      }

      // change to the last day of the current month
      calendar.setMonth(month + 1, 0);
      const lastDayInCurrentMonth = calendar.getDate();
      for (let i = 1; i <= lastDayInCurrentMonth; i++) {
        dates.push({ day: i, year, month, text: i, currentMonth: true });
      }

      const lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
      const nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;
      for (let i = 1; i <= nextMonthLength; i++) {
        dates.push({
          day: lastDayInCurrentMonth + i,
          year,
          month,
          text: i,
          currentMonth: false,
        });
      }

      return chunk(dates, 7);
    },
  },
  methods: {
    formatDate(date, format) {
      return format(date, format);
    },
    isSelected(day) {
      if (day.day > 0 && day.day <= 31) {
        return this.getDate(day).toDateString() === this.date.toDateString();
      }
      return false;
    },
    isToday(day) {
      let today = this.today;
      return (
        today.getFullYear() === day.year &&
        today.getMonth() === day.month &&
        today.getDate() === day.day
      );
    },
    selectDay(day) {
      let newDay = parseInt(day.day, 10);
      this.$emit("input", newDay);
      this.$emit("change", newDay);
    },
    getDate(day) {
      return new Date(this.calendarYear, this.calendarMonth, day.day);
    },
    hasRestriction(day) {
      if (this.minDate !== undefined) {
        if (this.calendarMinDate > this.getDate(day)) {
          return true;
        }
      }
      if (this.maxDate !== undefined) {
        if (this.calendarMaxDate < this.getDate(day)) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.day {
  width: 42px;
  height: 42px;

  &:hover {
    background-color: rgba(#5b8fcb, 0.3);
  }
}

.not-curent-month {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  background-color: rgba(lightgrey, 0.4);
}

.is-today {
  background-color: lightseagreen;
}
.not-available {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  background-color: rgba(lightgrey, 0.3);
}
</style>